module.exports = __webpack_public_path__ + "static/media/android2.d68492a2.png";